import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from '../../services/auth.service';
import { JournalService } from '../../services/journal.service';
import { TemoignageService } from '../../services/temoignage.service';
import { ReclamationService } from '../../services/reclamation.service';

type Onglet = 'ensemble' | 'evenements' | 'artistes' | 'archives' | 'temoignages' | 'reclamations' | 'sondages' | 'mediatheque' | 'affiches' | 'journal' | 'parametres';

@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.css']
})
export class DashboardComponent implements OnInit {

  ongletActif: Onglet = 'ensemble';
  nombreTemoignagesEnAttente = 0;
  nombreReclamationsEnAttente = 0;

  constructor(
    private authService: AuthService,
    private router: Router,
    private journalService: JournalService,
    private temoignageService: TemoignageService,
    private reclamationService: ReclamationService
  ) { }

  ngOnInit(): void {
    this.rafraichirCompteurTemoignages();
    this.rafraichirCompteurReclamations();
  }

  rafraichirCompteurTemoignages(): void {
    this.temoignageService.getAll().subscribe(data => {
      this.nombreTemoignagesEnAttente = data.filter(t => t.statut === 'attente').length;
    });
  }

  rafraichirCompteurReclamations(): void {
    this.reclamationService.getAll().subscribe(data => {
      this.nombreReclamationsEnAttente = data.filter(r => r.statut === 'en_attente').length;
    });
  }

  changerOnglet(onglet: Onglet): void {
    this.ongletActif = onglet;
    if (onglet === 'temoignages') {
      this.rafraichirCompteurTemoignages();
    }
    if (onglet === 'reclamations') {
      this.rafraichirCompteurReclamations();
    }
  }

  get username(): string | null {
    return this.authService.getUsername();
  }

  seDeconnecter(): void {
    this.authService.logout();
    this.router.navigate(['/admin/login']);
  }
}
